import { AxiosError } from 'axios';
import { useState } from 'react';

// import toast from 'react-hot-toast';
import { ToggleDashboardModeDataInterface } from '../../../models/dashboard/dashboard/togglesDashboardModeData';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../../models/https';
import useHttps from '../../useHttps';

const useToggleDashboardMode = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onToggleDashboardModeError = (err: AxiosError<ErrorHttpResponse>) => {
    // toast.error(err?.response?.data?.message ?? 'Something went wrong');
  };

  const onGetToggleDashboardModeSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<ToggleDashboardModeDataInterface>) => {
    // toast.success(message ?? 'Dashboard mode updated successfully');
    window.location.reload();
  };

  const getToggleDashboardMode = (data: { isTestMode: boolean }) => {
    const url: HttpConfig = {
      url: `api/v1/company/test-mode`,
      method: 'patch',
      data,
    };

    return request(
      url,
      onGetToggleDashboardModeSuccess,
      setLoading,
      onToggleDashboardModeError,
    );
  };

  return { getToggleDashboardMode, loading };
};

export default useToggleDashboardMode;
